/** Memories by Déjà Vu Nomad brand assets in /public/brand/memories */

/** High-contrast display serif — more refined than Playfair for the MEMORIES wordmark */
export const MEMORIES_DISPLAY_FONT = '"Cormorant Garamond", "Playfair Display", Georgia, serif';

export const memoriesWordmarkSx = {
  fontFamily: MEMORIES_DISPLAY_FONT,
  fontWeight: 400,
  fontStyle: 'normal',
  letterSpacing: '0.22em',
  lineHeight: 1,
  textTransform: 'uppercase',
};

export const MEMORIES_BRAND = {
  /** White stacked lockup for dark / oxblood backgrounds (opaque maroon plate) */
  primaryReversed: '/brand/memories/primary-reversed.png',
  /** Same lockup with maroon keyed out — use on DOCUMENT.nav */
  primaryReversedClear: '/brand/memories/primary-reversed-clear.png',
  /** Burgundy stacked lockup for light backgrounds */
  primary: '/brand/memories/primary.png',
  /** Horizontal lockup: mark | MEMORIES / BY DÉJÀ VU NOMAD */
  horizontal: '/brand/memories/horizontal.png',
  /** Boat mark only (dark) */
  mark: '/brand/memories/mark.png',
  /** Boat mark only (ivory, transparent) — for dark nav */
  markLight: '/brand/memories/mark-light.png',
  /** Square app icon — white boat on oxblood */
  appiconLight: '/brand/memories/appicon-light.png',
  /** Square app icon — full color */
  appicon: '/brand/memories/appicon.png',
  /** Large dark primary (JPEG) */
  primaryDark: '/brand/memories/primary-dark.jpg',
};
